export const sessionActivityExerciseStructure = {
    sessions: {
        1: {
            startId: 1,
            endId: 4,
        },
        2: {
            startId: 5,
            endId: 8,
        },
        3: {
            startId:9,
            endId: 12,
        },
        4: {
            startId:13,
            endId: 16,
        },
        5: {
            startId:17,
            endId: 20,
        },
        6: {
            startId:21,
            endId: 24,
        },
        7: {
            startId:25,
            endId: 28,
        },
        8: {
            startId:29,
            endId: 32,
        },
        9: {
            startId:33,
            endId: 36,
        },
        10: {
            startId:37,
            endId: 40,
        },
        11: {
            startId:41,
            endId: 44,
        },
        12: {
            startId:45,
            endId: 48
        },
        13: {
            startId:49,
            endId: 52
        },
        14: {
            startId:53,
            endId: 56
        },
        15: {
            startId:57,
            endId: 60
        },
        16: {
            startId:61,
            endId: 64
        },
        17: {
            startId:65,
            endId: 68
        },
        18: {
            startId:69,
            endId: 72
        },
        19: {
            startId:73,
            endId: 76
        },
        20: {
            startId:77,
            endId: 80
        },
    },
    ACTIVITIES_BY_SESSION: 4,
    EXERCISES_BY_ACTIVITY: 5
};